// extracted by mini-css-extract-plugin
module.exports = {"AccordionSection":"TermsSection_AccordionSection__1w7Ug"};